export default "__VITE_ASSET__DwZ50oB7__"